import { render, staticRenderFns } from "./TabelaEmailAreas.vue?vue&type=template&id=60bbf898"
import script from "./TabelaEmailAreas.vue?vue&type=script&lang=js"
export * from "./TabelaEmailAreas.vue?vue&type=script&lang=js"
import style0 from "./TabelaEmailAreas.vue?vue&type=style&index=0&id=60bbf898&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports